module.exports = __webpack_public_path__ + "img/image-17.a65e3db8.webp";